import React from 'react';
import { twMerge } from 'tailwind-merge';
export type BadgeTone = 'neutral' | 'brand' | 'positive' | 'warning' | 'critical';
const tones: Record<BadgeTone, string> = {
  neutral: 'bg-ink-100 text-ink-600 ring-ink-200',
  brand: 'bg-brand-50 text-brand-700 ring-brand-100',
  positive: 'bg-emerald-50 text-emerald-700 ring-emerald-100',
  warning: 'bg-amber-50 text-amber-700 ring-amber-100',
  critical: 'bg-rose-50 text-rose-700 ring-rose-100'
};
interface BadgeProps {
  children: React.ReactNode;
  tone?: BadgeTone;
  className?: string;
  icon?: React.ReactNode;
}
export function Badge({
  children,
  tone = 'neutral',
  className,
  icon
}: BadgeProps) {
  return <span className={twMerge('inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset', tones[tone], className)} data-id="element-365" data-mp="llmobadft4ek">
      {icon}
      {children}
    </span>;
}